import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { Observable } from 'rxjs';
import { AdminUserQuery } from '../admin-user.query';
import { AdminUserUIModel } from '../admin-user.model';

@Injectable()
export class AdminListViewService extends AbstractSimpleListViewService<AdminUserUIModel> {
  constructor(private readonly adminUserQuery: AdminUserQuery) {
    super();
  }

  readonly data$: Observable<AdminUserUIModel[]> = this.adminUserQuery.entities$;
  readonly loading$: Observable<boolean> = this.adminUserQuery.selectLoading();
}
